import React, { memo } from "react";
import { ContactInfo } from "components/molecules/ContactInfo";
import withMemberData from "../../hoc/withMemberData";
import { Stack } from "@mui/material";
import { Member } from "types/Member";
import { HomeCardSection } from "components/organisms/HomeCardSection";
import { HomeWelcomeSection } from "components/organisms/HomeWelcomeSection";
import { HomeTilesSection } from "components/organisms/HomeTilesSection";

export type HomeProps = {
  member?: Member;
  frontIdImgSrc?: string;
};

export const Home = memo(function Home({ member}: HomeProps): JSX.Element {
  return (
    <Stack component="main" spacing={4} sx={{ marginTop: 1, marginBottom: 2 }}>
      <HomeWelcomeSection member={member} />
      <HomeCardSection />
      <HomeTilesSection member={member} />
      <ContactInfo />
    </Stack>
  );
});

export default withMemberData(Home);
